import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const PREVIEWS = [
  ["HUMN Ai", "Start with what you want", "/app-screens/ai-chat.jpg"],
  ["Feed", "Discovery with purpose", "/app-screens/feed.jpg"],
  ["Learn", "Knowledge from people", "/v2/experience/sushi-chef.webp"],
  ["Join", "Real communities", "/app-screens/discovery.jpg"],
  ["My Happenings", "Everything together", "/app-screens/happenings.jpg"],
  ["Explore", "A world of intentions", "/app-screens/slm-grid.jpg"],
];

export const HomepageTeaser = () => (
  <section className="homepage-features" data-testid="homepage-features-teaser">
    <div className="features-shell">
      <p className="feature-index">04 · THE PRODUCT</p>
      <div className="homepage-features-heading">
        <h2 data-testid="homepage-features-title">ONE NETWORK. MANY WAYS<br />TO MAKE LIFE HAPPEN.</h2>
        <Link to="/features" className="v2-text-link" data-testid="homepage-teaser-explore-cta">Explore All Features <ArrowUpRight size={17} /></Link>
      </div>
      <div className="homepage-preview-rail">
        {PREVIEWS.map(([title, copy, image], index) => (
          <motion.article key={title} data-testid={`homepage-feature-preview-${index + 1}`} initial={{ opacity: 0, y: 36 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * .06 }}>
            <div className="homepage-preview-screen"><img src={image} alt={`${title} in HUMN`} loading="lazy" /></div>
            <small>0{index + 1}</small><strong>{title}</strong><span>{copy}</span>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);